// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"style_checkboxWrapper__nleK9","labelWrapper":"style_labelWrapper__g_aep","Checkbox":"style_Checkbox__ON9cY"};